// extracted by mini-css-extract-plugin
export default {"AIGBanner":"AlertBanner_AIGBanner__9k0v-","contentClass":"AlertBanner_contentClass__Cc1-T","closeBanner":"AlertBanner_closeBanner__kqJ23"};